<section class="sx" [class.is-open]="open">
  <button type="button" class="sx-head" (click)="open = !open" [attr.aria-expanded]="open">
    <span class="sx-head__icon"><i class="fas fa-calculator" aria-hidden="true"></i></span>
    <span class="sx-head__text">
      <span class="sx-head__title">How the course score works</span>
      <span class="sx-head__sub" *ngIf="context === 'course'">Pass Score here, Weight on each assessment</span>
      <span class="sx-head__sub" *ngIf="context === 'assessment'">How this assessment's Weight feeds the course's Pass Score</span>
    </span>
    <i class="fas fa-chevron-down sx-head__chevron" aria-hidden="true"></i>
  </button>

  <div class="sx-body" *ngIf="open">
    <ol class="sx-steps">
      <li>
        <span class="sx-steps__n">1</span>
        <div><b>Each assessment becomes a %</b><span>Marks scored ÷ marks available. 10 / 20 is 50%.</span></div>
      </li>
      <li>
        <span class="sx-steps__n">2</span>
        <div><b>Weight decides how much it counts</b><span>Set on each assessment. Weights don't need to add up to 100: 1 and 3 work like 25 and 75.</span></div>
      </li>
      <li>
        <span class="sx-steps__n">3</span>
        <div><b>Compared with the Pass Score</b><span>Set on the course. At or above it, the student passes. At 0, submitting everything is enough.</span></div>
      </li>
    </ol>

    <div class="sx-formula">
      <span>Course score</span> = <span class="sx-frac"><span>Σ (assessment % × weight)</span><span>Σ weights</span></span>
      <span class="sx-formula__vs" *ngIf="!noPassMark">≥ Pass Score ({{effectivePass}}%)</span>
      <span class="sx-formula__vs" *ngIf="noPassMark">No pass mark set (0%)</span>
    </div>

    <div class="sx-demo">
      <div class="sx-demo__head">
        <span *ngIf="!isDemo">This course's assessments</span>
        <span *ngIf="isDemo">Example course</span>
        <span class="sx-demo__note" *ngIf="!isDemo">Real weights · type example scores to try it</span>
        <span class="sx-demo__note" *ngIf="isDemo">No assessments yet · try changing the weights</span>
      </div>

      <p class="sx-loading" *ngIf="loading">Loading this course's assessments…</p>

      <ng-container *ngIf="!loading">
        <div class="sx-row sx-row--head">
          <span>Assessment</span><span>Example score</span><span>Weight</span><span>Counts for</span>
        </div>
        <div class="sx-row" *ngFor="let row of rows; let i = index"
             [class.is-this]="row.isThis" [class.is-out]="!counts(row)">
          <span class="sx-row__name" [title]="row.name">{{row.name}}</span>
          <span class="sx-pct">
            <input type="number" min="0" max="100" class="sx-input" [id]="'sx-p-' + i"
                   [(ngModel)]="row.examplePct" [ngModelOptions]="{ standalone: true }"
                   [disabled]="!counts(row)" [attr.aria-label]="'Example score for ' + row.name">
            <span>%</span>
          </span>
          <span>
            <input *ngIf="isDemo" type="number" min="0" max="100" class="sx-input" [id]="'sx-w-' + i"
                   [(ngModel)]="row.weight" [ngModelOptions]="{ standalone: true }" [attr.aria-label]="'Weight for ' + row.name">
            <b *ngIf="!isDemo">{{counts(row) ? row.weight : '–'}}</b>
          </span>
          <span class="sx-share" *ngIf="counts(row)">
            <span class="sx-share__bar"><span [style.width.%]="share(row)"></span></span>
            <b>{{share(row)}}%</b>
          </span>
          <span class="sx-out" *ngIf="!counts(row)">{{excludedReason(row)}} · doesn't count</span>
        </div>
        <p class="sx-fine" *ngIf="allWeightsZero">Every counted weight is 0, so they count equally.</p>
        <p class="sx-fine" *ngIf="context === 'assessment' && rows.length === 1 && countedRows.length === 1">
          This is the course's only counted assessment, so it decides the whole course score.
        </p>

        <div class="sx-result" [class.is-pass]="passed">
          <ng-container *ngIf="countedRows.length > 0; else nothingCounts">
            <div class="sx-result__score">
              <span class="sx-result__label">Course score</span>
              <span class="sx-result__value">{{score}}%</span>
              <span class="sx-result__verdict">{{passed ? 'Passes' : 'Below the pass score'}}</span>
            </div>
            <div class="sx-gauge" role="img" [attr.aria-label]="'Score ' + score + '% against a pass score of ' + effectivePass + '%'">
              <span class="sx-gauge__fill" [style.width.%]="score"></span>
              <span class="sx-gauge__pass" *ngIf="!noPassMark" [style.left.%]="effectivePass"><i>Pass {{effectivePass}}%</i></span>
            </div>
            <p class="sx-result__compare" *ngIf="noPassMark">Pass Score is 0, so any student who submits every counted assessment passes.</p>
          </ng-container>
          <ng-template #nothingCounts>
            <p class="sx-result__compare mb-0">No assessment counts yet, so every student passes once the course is complete.</p>
          </ng-template>
        </div>
      </ng-container>
    </div>

    <ul class="sx-rules">
      <li><i class="fas fa-check" aria-hidden="true"></i> Optional assessments and lesson quizzes don't count.</li>
      <li><i class="fas fa-check" aria-hidden="true"></i> Every counted assessment must be submitted before a student can pass.</li>
      <li><i class="fas fa-check" aria-hidden="true"></i> If every weight is 0, the assessments count equally.</li>
      <li><i class="fas fa-check" aria-hidden="true"></i> An assessment counts once it has questions.</li>
    </ul>
  </div>
</section>
